

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getDatabase, ref, set, push } from 'firebase/database';
import { app } from '../firebase'; // Ensure this path is correct
import { Divider, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import './InfoTale.css'

const InfoTable = () => {
    const [totalEstimatedCost, setTotalEstimatedCost] = useState(0);
    const [submitData, setsubmitData] = useState(false);

    const [totalPrice, setTotalPrice] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const data = location.state?.data || [];
    const formData = location.state?.formData || [];
    const ID = location.state?.id || [];
    const db = getDatabase(app);
    console.log('--------------------------------------------*****************',ID);
    
    const [showSuccess, setShowSuccess] = useState(false);

    const handleBack = () => {
        // navigate('/components/doorConfig');
        navigate(`/components/doorConfig/${undefined}`);
    };

    const fallingEmoji = `
    @keyframes fall {
      0% { top: -50px; opacity: 0; }
      50% { opacity: 1; }
      100% { top: 30px; opacity: 0; }
    }
  `;

//   const capitalize = (name) => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    const UserTablepage =()=>[
        navigate('/components/UserTable')
    ]

    const handleDownloadPDF = () => {
        const doc = new jsPDF();
        const imgData = './assets/logo.png'; // Replace with your image's base64 string
        const imgWidth = 30;
        const imgHeight = 28;
        const x = (doc.internal.pageSize.getWidth() - imgWidth) / 2;
        const y = 10;
        doc.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight);
    
        doc.setFontSize(20);
        doc.text("User Information", 14, 10 + imgHeight + 5);
    
        doc.autoTable({
            head: [['User', 'Details']],
            body: [
                ['First Name', formData.firstName],
                ['Last Name', formData.lastName],
                ['Address', formData.address],
                ['City', formData.city],
                ['State', formData.state],
                ['ZIP Code', formData.zipCode],
                ['Year Built', formData.yearBuilt],
                ['Phone', formData.phone],
                ['Cell', formData.cell],
                ['Work', formData.work],
            ],
            startY: 50,
        });
    
        const currentDate = new Date().toLocaleDateString();
        doc.setFontSize(12);
        const termsText = `Terms- 50% deposit is required to place order; the balance is due when door arrives at our
                warehouse in Baton Rouge. Doors take 12-16 weeks for fabrication and delivery
                to our Final balance due before door is installed or delivered. Since door is custom made,
                there is no cancellation of order, client is responsible for full payment. (initials)
                *Installation includes door, threshold, pull handles, weather-stripping, glass & wrapping
                of the door. Builder/Homeowner must leave door wrapped throughout the project. Any damage
                done to the door because it was unwrapped will be repaired and charged to homeowner at
                time and materials charges (in-field labor is $75/hr). No trims come with this door,
                unless specified above. This price is for standard installation. The homeowner will be
                billed at cost for any additional items necessary to complete the job in a
                satisfactory manner. Other than what is listed on the proposal, this does not include
                additional hardware, trims, wall painting, tile work or other unforeseen issues or any
                additional framing, etc.
                Please sign and date the proposal and drawing and return with your deposit. Orders are not
                processed until all documents are received (drawings, terms & cond, proposal, deposit).
                Thank you,
                Robby Turner
                Proposal Accepted and Approved by Customer:
                Date: ${currentDate}
                `;
        // const termsText = `...`; // Your terms text  

        const yPosition = doc.autoTable.previous.finalY + 10;
        const splitText = doc.splitTextToSize(termsText, 200);
        doc.text(splitText, 7, yPosition);
    
        doc.addPage();
        doc.setFontSize(20);
        doc.text("Door Configuration", 14, 20);

        // Create the table data and calculate totals
        let estimatedCostTotal = 0;
        let priceTotal = 0;

        const tableData = data.map((item, index) => {
            const field2 = item.additionalFields.field2 ? parseFloat(item.additionalFields.field2) : 0;
            const field3 = item.additionalFields.field3 ? parseFloat(item.additionalFields.field3) : 0;
            const field4 = item.additionalFields.field4 ? parseFloat(item.additionalFields.field4) : 0;
            const selectedOption = item.selectedOption ? parseFloat(item.selectedOption) : 0;

            // Calculate Estimated Cost
            let estimatedCost = 0;
            if (index === 0 || index === 17 || index === 18 || index === 20) {
                estimatedCost = field3 * field4;
            } else if ([3, 4, 8, 9, 19, 22, 24].includes(index)) {
                estimatedCost = field4;
            } else if ([10, 11].includes(index)) {
                estimatedCost = field2 * field4;
            } else if ([12, 14].includes(index)) {
                estimatedCost = selectedOption * field4;
            }

            // Calculate Price
            let price = 0;
            if (index === 19) {
                price = field4 * 2.5;
            } else if (index === 20) {
                price = (field3 * field4) * 2; // Adjust if this is not correct
            } else if ([12, 14].includes(index)) {
                price = (selectedOption * field4) * 2;
            } else if ([11, 10].includes(index)) {
                price = (field2 * field4) * 2;
            } else if ([0, 17, 18].includes(index)) {
                price = (field3 * field4) * 2.5;
            } else if ([8, 9, 11, 19, 22, 24].includes(index)) {
                price = field4 * 2;
            } else if ([3, 4].includes(index)) {
                price = field4 * 2.5;
            }

            estimatedCostTotal += estimatedCost;
            priceTotal += price;

            return {
                label: item.label,
                selectedOption: item.selectedOption,
                field1: item.additionalFields.field1 === "NO" || (index === 3 || index === 4) ? "French Arch" : item.additionalFields.field1,
                field2: item.additionalFields.field2,
                field3: item.additionalFields.field3,
                field4: item.additionalFields.field4,
                estimatedCost: estimatedCost.toFixed(2),
                price: price.toFixed(2),
            };
        });
        // Add table to PDF
        doc.autoTable({
            head: [['Category', 'Detail Type', 'Width (Inches)', 'Height (Inches)', 'Sqft/Lft', 'Unit Cost', 'Estimated Cost', 'Price']],
            body: tableData.map(item => [
                item.label,
                item.selectedOption,
                item.field1,
                item.field2,
                item.field3,
                item.field4,
                item.estimatedCost,
                item.price,
            ]),
            startY: 30,
        });

        // Add totals to PDF
        // const totalsYPosition = doc.autoTable.previous.finalY + 10;
        const totalsYPosition = doc.autoTable.previous.finalY + 10;
        doc.setFontSize(10);
        doc.text(`Total :     ${estimatedCostTotal.toFixed(2)}`, 142, totalsYPosition);
        doc.text(` ${priceTotal.toFixed(2)}`, 180, totalsYPosition); // Adjust the x position as needed
    
        doc.save('data-display.pdf');
    };
    

    const sendDataToFirebase = async (formData, data, userId) => {
        const doorData = data.map((item, index) => {
            // Existing code to calculate estimatedCost and price
            const field2 = item.additionalFields.field2 ? parseFloat(item.additionalFields.field2) : 0;
            const field3 = item.additionalFields.field3 ? parseFloat(item.additionalFields.field3) : 0;
            const field4 = item.additionalFields.field4 ? parseFloat(item.additionalFields.field4) : 0;
            const selectedOption = item.selectedOption ? parseFloat(item.selectedOption) : 0;
    
         // Calculate Estimated Cost
          let estimatedCost = 0;
          if (index === 0 || index === 17 || index === 18 || index === 20) {
              estimatedCost = field3 * field4;
          } else if ([3, 4, 8, 9, 19, 22, 24].includes(index)) {
              estimatedCost = field4;
          } else if ([10, 11].includes(index)) {
              estimatedCost = field2 * field4;
          } else if ([12, 14].includes(index)) {
              estimatedCost = selectedOption * field4;
          }





          // Calculate Price
          let price = 0;
          if (index === 19) {
              price = field4 * 2.5;
          } else if (index === 20) {
              price = (field3 * field4) * 2; // Adjust if this is not correct
          } else if ([12, 14].includes(index)) {
              price = (selectedOption * field4) * 2;
          } else if ([11, 10].includes(index)) {
              price = (field2 * field4) * 2;
          } else if ([0, 17, 18].includes(index)) {
              price = (field3 * field4) * 2.5;
          } else if ([8, 9, 11, 19, 22, 24].includes(index)) {
              price = field4 * 2;
          } else if ([3, 4].includes(index)) {
              price = field4 * 2.5;
          }


    
            return {
                label: item.label,
                selectedOption: item.selectedOption,
                additionalFields: {
                    field1: item.additionalFields.field1 || '',
                    field2: item.additionalFields.field2 || '',
                    field3: item.additionalFields.field3 || '',
                    field4: field4,
                    estimatedCost: estimatedCost.toFixed(2),
                    price: price.toFixed(2),
                },
            };
        });
    
        const userData = {
            name: `${formData.firstName} ${formData.lastName}`,
            formData,
            doorData,
            totalEstimatedCost: totalEstimatedCost.toFixed(2),
            totalPrice: totalPrice.toFixed(2),
            timestamp: new Date().toISOString(),
        };
    
        // If userId is provided, update the user data
        if (userId) {
            try {
                await set(ref(db, `users/${userId}`), userData);
                setShowSuccess(true);
                setTimeout(() => {
                    setShowSuccess(false);
                }, 3000);
            } catch (error) {
                console.error('Error updating data in Firebase:', error);
            }
        } else {
            // Otherwise, create a new user
            const newUserRef = push(ref(db, 'users'));
            try {
                await set(newUserRef, userData);
                setShowSuccess(true);
                setTimeout(() => {
                    setShowSuccess(false);
                }, 3000);
            } catch (error) {
                console.error('Error sending data to Firebase:', error);
            }
        }
    };
    
 

    const handleSubmitData = async () => {
        const userId = ID // Ensure userId is part of formData
        if ( userId == 'undefined'){
            await sendDataToFirebase(formData, data);

            console.log('----------------------------------------???????????????????');

        } else{
            console.log('----------------------------------------???????????????????111111');
            await sendDataToFirebase(formData, data, userId);
                       

        }
        // Pass userId to the function
        setsubmitData(true);
    };

    // const handleSubmitData = async () => {
    //    
    //     setsubmitData(true)
    // };

const closeDataDialog =()=>{
    setsubmitData(false)
}

    useEffect(() => {
        // Calculate totals for the displayed table
        let estimatedCostTotal = 0;
        let priceTotal = 0;

        data.forEach((item, index) => {
            const field2 = item.additionalFields.field2 ? parseFloat(item.additionalFields.field2) : 0;
            const field3 = item.additionalFields.field3 ? parseFloat(item.additionalFields.field3) : 0;
            const field4 = item.additionalFields.field4 ? parseFloat(item.additionalFields.field4) : 0;
            const selectedOption = item.selectedOption ? parseFloat(item.selectedOption) : 0;

           // Calculate Estimated Cost
           let estimatedCost = 0;
           if (index === 0 || index === 17 || index === 18 || index === 20) {
               estimatedCost = field3 * field4;
           } else if ([3, 4, 8, 9, 19, 22, 24].includes(index)) {
               estimatedCost = field4;
           } else if ([10, 11].includes(index)) {
               estimatedCost = field2 * field4;
           } else if ([12, 14].includes(index)) {
               estimatedCost = selectedOption * field4;
           }

           // Calculate Price
           let price = 0;
           if (index === 19) {
               price = field4 * 2.5;
           } else if (index === 20) {
               price = (field3 * field4) * 2; // Adjust if this is not correct
           } else if ([12, 14].includes(index)) {
               price = (selectedOption * field4) * 2;
           } else if ([11, 10].includes(index)) {
               price = (field2 * field4) * 2;
           } else if ([0, 17, 18].includes(index)) {
               price = (field3 * field4) * 2.5;
           } else if ([8, 9, 11, 19, 22, 24].includes(index)) {
               price = field4 * 2;
           } else if ([3, 4].includes(index)) {
               price = field4 * 2.5;
           }

            estimatedCostTotal += estimatedCost;
            priceTotal += price;
        });

        setTotalEstimatedCost(estimatedCostTotal);
        setTotalPrice(priceTotal);
    }, [data]);


    return (
        <div  style={{backgroundColor:'#5f1c1d'}}>
        <div class="container"  style={{backgroundColor:'white'}} >
        <div style={{ padding: '20px' }} >  
        <div className='responsive-table table-design'>     
            {showSuccess && <p style={{ color: 'green' }}>Data submitted successfully!</p>}
            {formData ? (
             
                 <table>
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td>First Name</td><td>{formData.firstName}</td></tr>
                        <tr><td>Last Name</td><td>{formData.lastName}</td></tr>
                        <tr><td>Address</td><td>{formData.address}</td></tr>
                        <tr><td>City</td><td>{formData.city}</td></tr>
                        <tr><td>State</td><td>{formData.state}</td></tr>
                        <tr><td>ZIP Code</td><td>{formData.zipCode}</td></tr>
                        <tr><td>Year Built</td><td>{formData.yearBuilt}</td></tr>
                        <tr><td>Phone</td><td>{formData.phone}</td></tr>
                        <tr><td>Cell</td><td>{formData.cell}</td></tr>
                        <tr><td>Work</td><td>{formData.work}</td></tr>
                    </tbody>
                </table> 
            ) : (
                <p>No form data submitted.</p>
            )}
            </div>
            <h3 style={{ textAlign: 'center', margin: '20px 5px', fontWeight: 'bold' }}>Door Configuration</h3>
           <div className='responsive-table table-design'>
            <table>
                <thead>
                    <tr>
                        <th>Category</th>
                        <th>Detail Type</th>
                        <th>Width (Inches)</th>
                        <th>Height (Inches)</th>
                        <th>Sqft/Lft</th>
                        <th>Unit Cost</th>
                        <th>Estimated Cost</th>
                        <th>Price</th>
                    </tr>
                </thead>
<tbody>
    {data.map((item, index) => {
        const field2 = item.additionalFields.field2 ? parseFloat(item.additionalFields.field2) : 0;
        const field3 = item.additionalFields.field3 ? parseFloat(item.additionalFields.field3) : 0;
        
        // Set field4 to 155 or 170 if empty for indices 13 or 14, otherwise use the actual value
        const field4 = item.additionalFields.field4 ? parseFloat(item.additionalFields.field4) : (index === 12 ? 155 : (index === 14 ? 170 : 0));
        const selectedOption = item.selectedOption ? parseFloat(item.selectedOption) : 0;

       // Calculate Estimated Cost
       let estimatedCost = 0;
       if (index === 0 || index === 17 || index === 18 || index === 20) {
           estimatedCost = field3 * field4;
       } else if ([3, 4, 8, 9, 19, 22, 24].includes(index)) {
           estimatedCost = field4;
       } else if ([10, 11].includes(index)) {
           estimatedCost = field2 * field4;
       } else if ([12, 14].includes(index)) {
           estimatedCost = selectedOption * field4;
       }

       // Calculate Price
       let price = 0;
       if (index === 19) {
           price = field4 * 2.5;
       } else if (index === 20) {
           price = (field3 * field4) * 2; // Adjust if this is not correct
       } else if ([12, 14].includes(index)) {
           price = (selectedOption * field4) * 2;
       } else if ([11, 10].includes(index)) {
           price = (field2 * field4) * 2;
       } else if ([0, 17, 18].includes(index)) {
           price = (field3 * field4) * 2.5;
       } else if ([8, 9, 11, 19, 22, 24].includes(index)) {
           price = field4 * 2;
       } else if ([3, 4].includes(index)) {
           price = field4 * 2.5;
       }

        return (
            <tr key={index}>
                <td>{item.label}</td>
                <td>{item.selectedOption}</td>
                <td>{item.additionalFields.field1 === "NO" || (index === 3 || index === 4) ? "French Arch" : item.additionalFields.field1}</td>
                <td>{item.additionalFields.field2}</td>
                <td>{item.additionalFields.field3}</td>
                <td>{field4}</td>
                <td>{estimatedCost.toFixed(2)}</td>
                <td>{price.toFixed(2)}</td>
            </tr>
        );
    })}
    {/* Total Row */}
    <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
        <td colSpan={6} style={{ textAlign: 'right' }}>Total:</td>
        <td>{totalEstimatedCost.toFixed(2)}</td>
        <td>{totalPrice.toFixed(2)}</td>
    </tr>
</tbody>
            </table>
            </div>
            {/* <div className='total-bar' style={{ textAlign: 'right', fontWeight: 'bold', marginTop: '20px' }}>
                <p><span>Total Estimated Cost :</span><span> {totalEstimatedCost.toFixed(2)}</span></p>
                <p><span>Total Price :</span> <span>{totalPrice.toFixed(2)}</span></p>
            </div> */}
            <div className='divcenter btn-bar' >
                <button className='Back button-design' onClick={handleBack}>Back</button>
                <button className='Next button-design' onClick={handleDownloadPDF}>Download PDF</button>
                <button className='Submit button-design' onClick={handleSubmitData}>Submit Data</button>
                 
                <button style={{marginLeft:'10px'}} className='Next button-design' onClick={UserTablepage}>See User Details</button>

            </div>
 
            <>
      {/* Injecting custom animation styles */}
      <style>
        {fallingEmoji}
      </style>
      
      <Dialog
        open={submitData}
        onClose={closeDataDialog}
        PaperProps={{
          style: {
            backgroundColor: '#d4edda', // Light green background for success
            padding: '20px',
            borderRadius: '10px',
          }
        }}
      >
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontWeight: 'bold', color: '#28a745' }}>🎉 Data Submitted Successfully</span>
            <span
              style={{ cursor: 'pointer', color: '#6c757d' }}
              onClick={closeDataDialog}
            >
              &#10006;
            </span>
          </div>
        </DialogTitle>
        <DialogContent>
          <div style={{ position: 'relative', height: '50px', overflow: 'hidden' }}>
            {/* Falling emoji */}
            <div style={{
              position: 'absolute',
              left: '38%',
              top: '-50px',
              fontSize: '30px',
              animation: 'fall 2s infinite'
            }}>
    🎉🎊✨
            </div>
            
          </div>
          <DialogContentText style={{ color: '#155724', fontWeight: 'bold', textAlign: 'center' }}>
  {formData.firstName && formData.firstName.charAt(0).toUpperCase() + formData.firstName.slice(1).toLowerCase()} 
  {' '}
    {formData.lastName && formData.lastName.charAt(0).toUpperCase() +   formData.lastName.slice(1).toLowerCase()} 
    {' '}
    Your data has been successfully posted! 🎉
</DialogContentText>

        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeDataDialog}
            style={{
              backgroundColor: '#28a745',
              color: '#fff',
              borderRadius: '4px',
              textTransform: 'none',
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
        </div> </div></div>
    ); 
};

export default InfoTable;
  